import { Enums } from "@flightscope/baseball-stats";

import { BaseballPitchTypeSeriesColorMapping } from "./BaseballPitchTypeSeriesColorMapping";
import { SoftballPitchTypeSeriesColorMapping } from "./SoftballPitchTypeSeriesColorMapping";

/**
 * @see https://docs.google.com/document/d/1CuDdyyptwcyPUZzB5jEPjaoPG0jTv4L-iycaPM2ylFI/edit
 *  @type {ColorMap}
 */
export default (process.env.VUE_APP_SPORT_TYPE === Enums.SportType.Baseball.key) ? BaseballPitchTypeSeriesColorMapping : SoftballPitchTypeSeriesColorMapping;
